import React, { ChangeEvent, useState, ReactElement } from 'react'
import { connectSearchBox } from 'react-instantsearch-dom'
import styled from '@emotion/styled'
import { AnimatePresence, motion } from 'motion/react'
import {
  Icon,
  Box,
  ResetButton,
  Flex,
  Input,
  theme,
} from '@mindfulchefuk/design-system'

type TSearchBoxParams = {
  defaultRefinement?: string
  refine(val: string): void
  placeholder?: string
}

const AnimatedClose = styled(motion.div)`
  display: flex;
  position: absolute;
  right: ${theme.space[16]};
  padding-top: ${theme.space[1]}
  padding-right: ${theme.space[4]}
  z-index: 2;
  background: ${theme.colors.white}
`

const AnimatedSearch = styled(motion.div)`
  display: flex;
  position: absolute;
  right: ${theme.space[16]};
`

const initial = { scale: 0 }
const animation = {
  scale: 1,
  transition: { type: 'spring', bounce: 0.54 },
}

// Just exported for testing
export const UnconnectedSearchBox = ({
  defaultRefinement = '',
  refine,
  placeholder,
}: TSearchBoxParams): ReactElement => {
  const [val, setVal] = useState(defaultRefinement)

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const { value } = event.currentTarget
    setVal(value)
    refine(value.length >= 3 ? value : '')
  }

  const handleReset = () => {
    setVal('')
    refine('')
  }

  return (
    <Box my={32} position="relative">
      <Flex justifyContent="flex-end" alignItems="center" position="relative">
        <Input
          type="search"
          value={val}
          autoFocus
          onChange={handleChange}
          placeholder={placeholder}
        />

        <AnimatePresence initial={false}>
          {!val && (
            <AnimatedSearch
              data-testid="nonsense"
              key="search"
              initial={initial}
              animate={animation}
            >
              <Icon type="search" size={32} />
            </AnimatedSearch>
          )}

          {val && (
            <AnimatedClose key="close" initial={initial} animate={animation}>
              <ResetButton onClick={handleReset} display="flex">
                <Icon type="thick-cross" size={24} />
              </ResetButton>
            </AnimatedClose>
          )}
        </AnimatePresence>
      </Flex>
    </Box>
  )
}

export const SearchBox = connectSearchBox(UnconnectedSearchBox)
